// Participa.js
import React from "react";
import "./Participa.css";

function Participa() {
  return (
    <section className="participa-section">
      <h2 className="participa-title">PARTICIPA</h2>
      <div className="participa-content">
        <p className="participa-text">
          Vols formar part del Casal Popular La Flama? Els sòcis/es del casal
          fem una aportació (que pot ser mensual, trimestral o anual, tu tries!)
          per participar entre totes del manteniment de l’espai i les
          activitats. L’aportació estàndard és de 8€/mes, però pot ser
          modificada segons la teva situació personal.
        </p>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSeg7f_ucxeBr9YbUrrAQc7H4bbBhs7en6BCPT4GKwb2mzGjwg/viewform"
          target="_blank"
          rel="noreferrer"
          className="participa-link"
        >
          FES-TE SOCI
        </a>
      </div>
    </section>
  );
}

export default Participa;
